export interface Media {
  hash: string;
  name: string;
  table: string;
  attribute: string;
  id: number;
}
